<template>
<div class="chapter">
<div class="inner_page">
<div class="section">
<div class="header">
<div class="hgroup">
<h3></h3>
<h1>1</h1>
</div>
</div>
<p class="first">
<span style="font-size: 1em; line-height: 1.5; text-indent: 1.5em;">Karen Champion tried to open her eyes. If she could just wake up in time, everything could still be all right. She would be here in bed in her apartment, the shades down, the doors locked, the black night shut out.</span></p>
<p class="para">
	But the dream, the nightmare, was on its way.</p>
<p class="para">
	She was hurrying along a silent street, and something was coming after her, very fast. It was dark, this follower, and when she looked back she could see that it was quite small. It seemed to be wearing a dress; she could see the whipping fabric in the wind. But the face was hairy, an animal muzzle glistening wetly with foam.</p>
<p class="para">
	In a moment its outstretched hand, palm forward, would touch her, the animal face would laugh, the foam would spray about her. She had to get away. But she couldn’t. If she took one backward step she would fall and fall and die …</p>
<p class="para">
	Now she wanted terribly to wake up. She made one tremendous, convulsive effort without moving a muscle. Karen tried to scream.</p>
<p class="para">
	A heavy crash in the bedroom released her from her bondage. She leaped awake in a single second. She was sitting upright in bed, her eyes wide open, her heart thudding with triphammer blows.</p>
<p class="para">
	What had the noise been? A crash? Had she dreamed it? The window shade was up, flooding the bed with moonlight. She shivered as the cold air flowed around her. Was it the shade, flying up, that woke her? And why was she so frightened?</p>
<p class="para">
	It must have been a dream, she told herself shakily, swinging her feet out of bed. She couldn’t sleep with all that moonlight shining on her face. She would close the shade again. Groping after the dream, she threw the bedclothes aside. A terrifying dream about—what? Something chasing her, that much she knew. Something too awful to look at. For some reason she found herself thinking of poor old Spot, dead and buried twenty years at least. Whatever had been in the nightmare, it certainly wasn’t Spot. The dream seemed to tatter into fragments as she tried to recapture it.</p>
<p class="para">
	Groping with one bare foot for her slippers, she felt her toe touch something slick and cold. She said aloud, “What in the world—” and bent to look. In absolute disbelief she saw the shattered fragments of a little glass lamp scattered across the carpet, broken edges gleaming wickedly in the moonlight.</p>
<p class="para">
	She thought dazedly, “I must be dreaming,” and turned toward the bureau where the two glass lamps should be standing.</p>
<p class="para">
	A dark shape moved between her and the bureau.</p>
<p class="para">
	This was the nightmare come to life, the dark follower moving into reality at last. Her heart contracted and seemed to stop. She tried to scream, but her throat wouldn’t open. She could only stare.</p>
<p class="para">
	She knew she wasn’t dreaming. This time it was real.</p>
<p class="para">
	The figure loomed toward her in the shadow, a black thing with eyes that seemed to strike sparks from the moonlight. The breath came so short in her throat that she couldn’t get air enough down into her lungs. One of the dark arms was raised, holding something that glittered from a dozen trembling points of light.</p>
<p class="para">
	Then it came toward her into the moonlight.</p>
<p class="para">
	She had one glimpse of a face she surely knew. The glint of the eyes was from horn-rimmed glasses. The moustache and the shadows hid the mouth, but surely, surely—</p>
<p class="para">
	“Dennis?” she asked in a little, shaken voice.</p>
<p class="para">
	The figure heaved up its arm and struck downward at her. It struck with the other glass lamp as a weapon. Karen’s throat opened and she screamed wildly, mindlessly, an animal noise, as she lurched sidewise in a frantic effort to escape.</p>
<p class="para">
	The lamp struck the wooden headboard with a splintering crash, making the whole bed rock under its impact. Bits of glass flew past her face. She sucked air deep into her lungs and shrieked again and again.</p>
<p class="para">
	Windows thudded open outside in the court of the apartment house. Someone called in sleepy alarm.</p>
<p class="para">
	The dark figure chuckled and backed away from the bed. Karen heard the door open and close. She sat still, without breathing or stirring, until the outer door opened and shut too.</p>
<p class="para">
	Then, barefoot, careless of the glass on the floor, she hurled herself across the room toward the telephone. Her hands shook so hard she couldn’t dial. She spun <i>O</i> for Operator after great effort.</p>
<p class="para">
	“Get the police!” she gasped into the shaking black mouth of the instrument. “Quick, quick! This is Karen Champion—my husband just tried to kill me!”</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_chapter01.vue?1b4e2798